/**
 * 登录 相关请求模块
 */
import { api } from '@/commomFun/api'

/**
 * 微信扫码获取绑定的用户信息
 */
function getUserBindInfo({ code }) {
  return api.getApiSpecil('/platform/wxQrCodeBind/getUserBindInfo', { code })
}

/**
 * 微信扫码登录
 */
function wxQrcodeLogin({ phone, userName, companyId, roleId, wxUnionId }, headers) {
  return api.postApi(
    '/login/wxQrcodeLoginIn',
    {
      phone,
      userName,
      companyId,
      roleId,
      wxUnionId
    },
    headers
  )
}

/**
 * 发送手机验证码
 */
function sendVerifyCode({ phone }) {
  return api.postApi('/login/sendVerifyCode', {
    phone
  })
}

/**
 * 登录选择用户（如果有多个）
 */
function loginUserList({ phone, code }) {
  return api.postApi('/login/loginUserList', {
    phone,
    code
  })
}

/**
 * 手机号验证码登录
 */
function phoneCodeLogin(
  {
    // 是否经过微信扫码,经过微信扫码就true,不传默认false
    fromWxQrCode,
    wxOpenId,
    wxUnionId,
    code,
    phone,
    userName,
    companyId,
    roleId
  },
  headers
) {
  return api.postApi(
    '/login/phoneLoginIn',
    {
      fromWxQrCode,
      wxOpenId,
      wxUnionId,
      code,
      phone,
      userName,
      companyId,
      roleId
    },
    headers
  )
}

/**
 * 用户绑定微信
 */
function userToBindWxTpAccount({ code }) {
  return api.getApiSpecil('/platform/wxQrCodeBind/userToBindWxTpAccount', { code })
}

/**
 * 查询是否弹出绑定微信提醒
 * uType: 1=是否提醒；2=设置提醒，都返回boolean类型；3=提醒天数，int类型
 */
function needWxBindRemind() {
  return api.getApiSpecil('/platform/wxQrCodeBind/needWxBindRemind')
}

/**
 * 获取微信绑定不提醒的天数接口
 */
function getWxBindNotRemindDays() {
  return api.getApiSpecil('/platform/wxQrCodeBind/getWxBindNotRemindDays')
}

/**
 * 设置固定时间内不提醒微信绑定
 */
function setupWxBindNotRemind() {
  return api.getApiSpecil('/platform/wxQrCodeBind/setupWxBindNotRemind')
}

export {
  // 微信扫码获取绑定的用户信息
  getUserBindInfo,
  // 微信扫码登录
  wxQrcodeLogin,
  // 发送手机验证码
  sendVerifyCode,
  // 登录选择用户（如果有多个）
  loginUserList,
  // 手机号验证码登录
  phoneCodeLogin,
  // 用户绑定微信
  userToBindWxTpAccount,
  // 查询是否弹出绑定微信提醒
  needWxBindRemind,
  // 获取微信绑定不提醒的天数接口
  getWxBindNotRemindDays,
  // 设置固定时间内不提醒微信绑定
  setupWxBindNotRemind
}
